@if (identifiersEnabled.includes('msisdn')) {
  <app-msisdn-input
      [passedFormControl]="formControl"
      [formErrors]="formErrors"
      [readonly]="readonly"
      (editClicked)="editClicked.emit(true)"
      [showErrors]="showErrors"/>
}
@if (identifiersEnabled.includes('email')) {
  <div class="form-group label-static"
       [ngClass]="{'is-focused': $any(input).isFocused}"
  >
    <label class="control-label">{{ 'attributes.email' | translate }}</label>
    <div [class.input-group]="readonly">
      <input [formControl]="formControl"
             #input
             appFocusable
             (onFocusChange)="$any(input).isFocused = $event"
             required
             class="form-control"
             [name]="settings.slug + '_email'"
             [readonly]="readonly"
             autocomplete="off">
      @if (readonly) {
        <span class="input-group-btn">
            <button class="btn btn-default" type="button" (click)="editClicked.emit(true); input.focus()"><i
                class="icon icon-pencil" aria-hidden="true"></i></button>
          </span>
      }
    </div>
  </div>
}
